import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  withAccessDenied,
  withRefresh,
  withProgressAndErrorMessage,
  withNotifications,
  withRouter,
} from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import { syncVirtualSwitches } from '@app/actions/virtualSwitches/virtualSwitches'
import {
  saveActionDeviceNumber, saveActionDescription,
} from '@app/actions/scenes/currentSceneCreating'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectVirtualSwitchAction
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/VirtualSwitchAction/SelectVirtualSwitchAction/SelectVirtualSwitchAction'
import SelectVirtualSwitchActionIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/VirtualSwitchAction/SelectVirtualSwitchAction/SelectVirtualSwitchAction'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectVirtualSwitchActionIOS) : withStyles(SelectVirtualSwitchAction)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { virtualSwitches } = state.virtualSwitches
  return {
    isMobile,
    virtualSwitches,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  refresh: syncVirtualSwitches,
  tryAgain: syncVirtualSwitches,
  saveActionDeviceNumber,
  saveActionDescription,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectVirtualSwitchActionEnhanced = enhance

export default withRouter(SelectVirtualSwitchActionEnhanced)
